/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';
import { InventoryEntryModel } from '../model/inventoryEntryModel';
import { SmartDineResponseInventoryEntryModel } from '../model/smartDineResponseInventoryEntryModel';
import { SmartDineResponseListInventoryEntryModel } from '../model/smartDineResponseListInventoryEntryModel';
import { SortByParam } from '../model/sortByParam';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class InventoryEntryControllerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  private getHeaders(
    consumes: string[] = ['application/json'],
    accepts: string[] = ['*/*']
  ): HttpHeaders {
    let headers = this.defaultHeaders;

    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    const acceptHeader = this.configuration.selectHeaderAccept(accepts);
    if (acceptHeader) {
      headers = headers.set('Accept', acceptHeader);
    }

    const contentTypeHeader =
      this.configuration.selectHeaderContentType(consumes);
    if (contentTypeHeader) {
      headers = headers.set('Content-Type', contentTypeHeader);
    }

    return headers;
  }

  private buildQueryParams(params: Record<string, any>): HttpParams {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((v) => {
            queryParameters = queryParameters.append(key, v);
          });
        } else {
          queryParameters = queryParameters.set(key, value);
        }
      }
    });
    return queryParameters;
  }

  private request<T>(
    method: string,
    path: string,
    body: any = null,
    queryParams: Record<string, any> = {},
    consumes: string[] = ['application/json'],
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    const headers = this.getHeaders(consumes);
    const params = this.buildQueryParams(queryParams);

    return this.httpClient.request<T>(method, `${this.basePath}${path}`, {
      body,
      params,
      withCredentials: this.configuration.withCredentials,
      headers,
      observe,
      reportProgress,
    });
  }

  public createInventoryEntry(
    body: InventoryEntryModel,
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<SmartDineResponseInventoryEntryModel> {
    if (!body || !restaurantId || !restaurantBranchId) {
      throw new Error('Missing required parameters for createInventoryEntry.');
    }

    return this.request<SmartDineResponseInventoryEntryModel>(
      'post',
      '/api/admin/inventoryentries',
      body,
      { restaurantId, restaurantBranchId, inventoryMasterId },
      ['application/json'],
      observe,
      reportProgress
    );
  }

  public deleteInventoryEntry(
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId: string,
    inventoryEntryId: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<SmartDineResponseInventoryEntryModel> {
    if (
      !restaurantId ||
      !restaurantBranchId ||
      !inventoryMasterId ||
      !inventoryEntryId
    ) {
      throw new Error('Missing required parameters for deleteInventoryEntry.');
    }

    return this.request<SmartDineResponseInventoryEntryModel>(
      'delete',
      `/api/admin/inventoryentries/${encodeURIComponent(
        String(inventoryEntryId)
      )}`,
      null,
      { restaurantId, restaurantBranchId, inventoryMasterId },
      [],
      observe,
      reportProgress
    );
  }

  public getInventoryEntries(
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId: string,
    pageNo?: number,
    pageSize?: number,
    sortByParams?: Array<SortByParam>,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<SmartDineResponseListInventoryEntryModel> {
    if (!restaurantId || !restaurantBranchId || !inventoryMasterId) {
      throw new Error('Missing required parameters for getInventoryEntries.');
    }

    return this.request<SmartDineResponseListInventoryEntryModel>(
      'get',
      '/api/admin/inventoryentries',
      null,
      {
        restaurantId,
        restaurantBranchId,
        inventoryMasterId,
        pageNo,
        pageSize,
        sortByParams,
      },
      [],
      observe,
      reportProgress
    );
  }

  public getInventoryEntry(
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId: string,
    inventoryEntryId: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<SmartDineResponseInventoryEntryModel> {
    if (
      !restaurantId ||
      !restaurantBranchId ||
      !inventoryMasterId ||
      !inventoryEntryId
    ) {
      throw new Error('Missing required parameters for getInventoryEntry.');
    }

    return this.request<SmartDineResponseInventoryEntryModel>(
      'get',
      `/api/admin/inventoryentries/${encodeURIComponent(
        String(inventoryEntryId)
      )}`,
      null,
      { restaurantId, restaurantBranchId, inventoryMasterId },
      [],
      observe,
      reportProgress
    );
  }

  public updateInventoryEntry(
    body: InventoryEntryModel,
    restaurantId: string,
    restaurantBranchId: string,
    inventoryMasterId?: string,
    inventoryEntryId?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<SmartDineResponseInventoryEntryModel> {
    if (
      !body ||
      !restaurantId ||
      !restaurantBranchId ||
      !inventoryMasterId ||
      !inventoryEntryId
    ) {
      throw new Error('Missing required parameters for updateInventoryEntry.');
    }

    return this.request<SmartDineResponseInventoryEntryModel>(
      'put',
      `/api/admin/inventoryentries/${encodeURIComponent(
        String(inventoryEntryId)
      )}`,
      body,
      { restaurantId, restaurantBranchId, inventoryMasterId },
      ['application/json'],
      observe,
      reportProgress
    );
  }
}
